export default __webpack_public_path__ + "static/media/github.553c6615.png";